function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.19557 7.40236C0.904039 7.66274 0.45122 7.64187 0.18567 7.35565C-0.0795427 7.06944 -0.0579477 6.62488 0.233246 6.36451L6.87639 0.426586C7.51243 -0.142195 8.48757 -0.142195 9.12361 0.426586L11.9579 2.9601V2.07397C11.9579 1.82916 12.1621 1.62875 12.4114 1.62875H13.4372C13.6866 1.62875 13.8907 1.82916 13.8907 2.07397V4.68765L15.7668 6.36451C16.0579 6.62488 16.0795 7.06944 15.8143 7.35565C15.5488 7.64187 15.096 7.66274 14.8044 7.40236C12.5069 5.34852 10.5185 3.57128 8.16129 1.46444C8.07086 1.38328 7.92914 1.38328 7.83871 1.46444L1.19557 7.40236Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3999 7.65208V13.3492C13.3999 13.8653 12.9714 14.2863 12.4457 14.2863H9.22737V9.51942H5.8869V14.2863H2.66858C2.14288 14.2863 1.71436 13.8653 1.71436 13.3492V7.65208L7.55713 2.42969L13.3999 7.65208Z",
  fill: "currentColor"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d8789b92.svg";
export { ForwardRef as ReactComponent };